import React from 'react';
import { render } from 'react-dom';
import { init, notifyLoadSucceeded, ready, register } from 'azure-devops-extension-sdk';
import { openPanel } from './Dialoghelper';
import { appInsights } from './telemetry/TelemetryService';
// Flag to prevent multiple panel opens - only resets when panel closes
let isPanelOpen = false;
let sdkReady = false;
const openPanelSafe = async () => {
    appInsights.trackTrace({
        message: '[Main] openPanelSafe called, isPanelOpen: ' + isPanelOpen + ', sdkReady: ' + sdkReady,
    });
    if (isPanelOpen) {
        appInsights.trackTrace({ message: '[Main] Panel already open, ignoring click' });
        return;
    }
    // Wait for SDK to be ready before opening panel
    if (!sdkReady) {
        appInsights.trackTrace({ message: '[Main] SDK not ready yet, waiting...' });
        try {
            await ready();
            sdkReady = true;
            appInsights.trackTrace({ message: '[Main] SDK now ready, proceeding to open panel' });
        }
        catch (error) {
            appInsights.trackException({ error: error, severityLevel: 2 });
            return;
        }
    }
    isPanelOpen = true;
    appInsights.trackTrace({ message: '[Main] Opening panel...' });
    try {
        await openPanel('\u00A0\u00A0DevOps Assistant', '', 'adocopilotui-panel', {}, () => {
            appInsights.trackTrace({ message: '[Main] Panel onClose callback fired' });
            isPanelOpen = false;
        });
    }
    catch (error) {
        appInsights.trackException({ error: error, severityLevel: 2 });
        isPanelOpen = false; // Reset flag on error
    }
};
// CRITICAL: Register handler BEFORE init() so Azure DevOps can find it when user clicks
appInsights.trackTrace({
    message: '[Main] Registering right-corner-menu handler at module load time',
});
register('right-corner-menu', () => {
    appInsights.trackTrace({ message: '[Main] Handler factory invoked' });
    return {
        execute: () => {
            appInsights.trackTrace({ message: '[Main] Execute called' });
            openPanelSafe();
        },
    };
});
// Initialize SDK after registration
init({ applyTheme: true, loaded: false })
    .then(() => {
    appInsights.trackTrace({ message: '[Main] SDK init complete' });
    return ready();
})
    .then(() => {
    sdkReady = true;
    appInsights.trackTrace({ message: '[Main] SDK ready, calling notifyLoadSucceeded' });
    notifyLoadSucceeded();
})
    .catch((error) => {
    appInsights.trackException({ error, severityLevel: 2 });
});
const IconExtension = () => {
    return null;
};
export default React.memo(IconExtension);
export function showRootComponent(component) {
    const rootElement = document.getElementById('root');
    if (rootElement) {
        appInsights.trackTrace({ message: '[Main] Rendering root component' });
        render(component, rootElement);
        appInsights.trackTrace({ message: '[Main] Component rendered successfully' });
    }
    else {
        const error = new Error('Root element not found');
        appInsights.trackException({ error, severityLevel: 3 });
        throw error;
    }
}
// Conditionally call showRootComponent only when not in a test environment
if (process.env.NODE_ENV !== 'test') {
    showRootComponent(React.createElement(IconExtension, null));
}
